import * as React from 'react';
import { PageChorinitia } from '../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../types/UserRole';
import { Schedule, Props } from './internalComponents/Schedule';
import LoginServices from '../../services/LoginServices';
import { Link } from 'react-router-dom';

interface State  {
}

/**
 * Ce composant permet d'afficher la page du planning
 */
export class SchedulePage extends React.Component {
    state: State;

    constructor(props: Props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <PageChorinitia
                allowedUsers={[
                    UserRole.ADMIN,
                    UserRole.MEMBER,
                    UserRole.SEMI_PRO,
                ]}
            >
                <div style={{paddingBottom: '20px'}}>
                    {this.EventAddButton()}
                    <Schedule title={''}/>

                </div>
            </PageChorinitia>
        );
    }

    private EventAddButton(): JSX.Element | undefined {
        const userRole = LoginServices.getInstance().getType();

        if (
            userRole === UserRole.MEMBER.toString() ||
            userRole === UserRole.USER.toString() ||
            userRole === UserRole.SEMI_PRO.toString()
        ) {
            return undefined;
        } else if (
            userRole === UserRole.ADMIN.toString()
        ) {
            return (
                <Link to="/schedule/create">
                    <button
                        className="btn btn-outline-secondary font-weight-bold"
                        style={{marginTop: '20px'}}
                    >
                        Créer Un Evènement
                    </button>
                </Link>
            );
        }
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/components/SchedulePage/SchedulePage.tsx